//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import StateBox from "../../../../component/content/StateBox";
import CancelProductInfo from "../../../../component/content/CancelProductInfo";
import UserInfo from "../../../../component/content/UserInfo";
import PaymentInfo from "../../../../component/content/PaymentInfo";
import CancelInfo from "../../../../component/content/Cancelnfo";
import AddressInfo from "../../../../component/content/AddressInfo";

// img
import more from "../../../../assets/img/icon/icon_more2.svg";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MyCancelDetail(props) {
    //페이지 이동
    const navigate = useNavigate();
    const goDetailPage = () => {
        navigate.push(`/product/detail/:` + props.i);
    };

    return (
        <Wrap>
            {/* 타이틀 */}
            {/* <MyPageTitleBox>
                       
                    </MyPageTitleBox> */}

            <Article>
                <MyPageTitle>주문상세내역</MyPageTitle>
                {/* 테이블 제목 */}
                <TabelTitle>
                    <TabelText>
                        <PC>주문일자</PC> <span>2021.12.13</span>
                    </TabelText>
                    <TabelText>
                        <PC>주문번호</PC> <span>28000120222041</span>
                        <MoreBtn>
                            <img src={more} alt="화살표 아이콘" />
                        </MoreBtn>
                    </TabelText>
                </TabelTitle>

                {/* 주문상세내역 */}
                <StateBoxWrap>
                    <StateBox />
                </StateBoxWrap>
            </Article>

            {/* 주문상품정보 */}
            <Article>
                <CancelProductInfo />
            </Article>

            {/* 구매자 정보 */}
            <Article>
                <UserInfo />
            </Article>

            {/* 결제 정보 */}
            <Article>
                <PaymentInfo />
            </Article>

            {/* 취소/환불정보 */}
            <Article>
                <CancelInfo />
            </Article>

            {/* 배송지 정보 */}
            <Article>
                <AddressInfo />
            </Article>
        </Wrap>
    );
}

const Wrap = styled.section`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-bottom: ${M(20)};
    }
`;
const Article = styled.article`
    &:not(:first-child) {
        margin-top: calc(100vw * (50 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (50 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            margin-top: ${M(30)};
        }
    }
`;
const TabelTitle = styled.div`
    display: flex;
    align-items: center;

    padding: calc(100vw * (20 / 1920)) 0;

    border-top: 1px solid #000;
    // border-bottom: 1px solid #DDDDDD;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        justify-content: space-between;
        padding: ${M(20)} 0;
    }
`;

const StateBoxWrap = styled.div`
    margin-bottom: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(30)};
    }
`;

const TabelText = styled.p`
    display: flex;
    align-items: center;

    font-family: "Noto-R";
    font-size: calc(100vw * (15 / 1920));

    & span {
        font-family: "Noto-M";
        margin-left: calc(100vw * (10 / 1920));
    }

    &:first-child {
        margin-right: calc(100vw * (40 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        & span {
            margin-left: calc(100vw * (10 / 1300));
        }

        &:first-child {
            margin-right: calc(100vw * (40 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        & span {
            margin-left: 0;
        }

        & span:not(:first-child) {
            margin-left: ${M(13)};
        }

        &:first-child {
            margin-right: 0;
        }
    }
`;

const MoreBtn = styled.span`
    display: flex;
    align-items: center;

    width: calc(100vw * (5 / 1920));
    height: calc(100vw * (10 / 1920));
    margin-left: calc(100vw * (10 / 1920));

    & img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (5 / 1300));
        height: calc(100vw * (10 / 1300));
        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(5)};
        height: ${M(10)};
        margin-left: ${M(10)};
    }
`;
